/**
 * GranGuard brand for the ungated later-life face (granguard.scamdefense.org).
 *
 * Unlike the DCUC/AMBA builds this is not a co-brand: GranGuard is the single
 * go-to-market identity (decision 2026-07-28), so the wordmark stands alone
 * and the host is infrastructure the visitor never has to think about.
 *
 * The base violet ramp in app.css is already GranGuard's palette, so this
 * face deliberately ships no `.theme-*` override.
 */

/** GranGuard's brand violet, matching --color-violet-600 in the base theme. */
export const GG_VIOLET = '#7c3aed'

export const GG_EMAIL = 'info@granguard.org'

/**
 * Full GranGuard lockup (shield + wordmark + "Scam Defense" rule).
 * `onDark` swaps to the reversed-out artwork for navy/violet backgrounds.
 *
 * Sized by height; the source art is 634x163 so width follows naturally.
 */
export function GranGuardMark({
  onDark = false,
  className = 'h-9',
}: {
  onDark?: boolean
  className?: string
}) {
  return (
    <img
      src={onDark ? '/granguard-logo-dark.png' : '/granguard-logo.png'}
      alt="GranGuard"
      className={`w-auto ${className}`}
      width={634}
      height={163}
    />
  )
}
